import { AppStateModel } from "../app-state.model";
import { createSelector } from "@ngrx/store";
import { FeatureFlagTeleAdviceStateModel, FeatureFlagHillsPostAdoptionDTCStateModel, FeatureFlagInsuranceStateModel } from "./feature-flags.reducer";

export const selectFeatureFlagTeleAdviceFeature = (state: AppStateModel) => state.featureFlagTeleAdvice;
export const selectFeatureFlagTeleAdvice =
  createSelector(selectFeatureFlagTeleAdviceFeature, (state: FeatureFlagTeleAdviceStateModel) => state.teleAdvice);

export const selectFeatureFlagHillsPostAdoptionDTCFeature = (state: AppStateModel) => state.featureFlagHillsPostAdoptionDTC;
export const selectFeatureFlagHillsPostAdoptionDTC =
  createSelector(selectFeatureFlagHillsPostAdoptionDTCFeature, (state: FeatureFlagHillsPostAdoptionDTCStateModel) => state.hillsPostAdoptionDTC);

export const selectFeatureFlagInsuranceFeature = (state: AppStateModel) =>
  state.featureFlagInsurance;

export const selectFeatureFlagInsurance = createSelector(
  selectFeatureFlagInsuranceFeature,
  (state: FeatureFlagInsuranceStateModel) => state.insurance
);